export default {
  login_prompt: "Sign in",
  register_prompt: "Register",
  logout: "Log out",
  forgotten_password_prompt: "Forgot password?",
  forgotten_password_message:
    "Forgotten your password? Follow the the link above to request a password reset.",
  forgotten_explanation: "Please enter your RCA email",
  first_name: "First name",
  first_name_placeholder: "First name(s)",
  last_name: "Last name",
  last_name_placeholder: "Last name(s)",
  full_name_label: "Full name",
  email: "email",
  email_placeholder: "yourname@mail.com",
  edit_password: "edit password",
  hide_edit_password: "keep current password",
  password: "Password",
  confirm_password: "Confirm",
  programme_deadline_expired: "Submissions for your programme ended on",
  invalid_username_or_password: "Invalid username or password",
  confirm_password_placeholder: "Confirm password",
  first_name_minlength_message: "First name needs at least two characters",
  last_name_minlength_message: "Last name needs at least two characters",
  email_invalid_message: "First enter a valid email address",
  password_invalid_format_message: `Invalid password format.`,
  password_minlength_message: "Password needs at least 8 characters",
  passwords_not_match_message: "The password fields do not match",
  reset_label: "Please reset your password",
  submit_label_signin: "Sign in",
  submit_label_register: "Register",
  submit_label_forgotten: "Send login link",
  email_not_matched: "Email address not found",
  sent_reset_email:
    "We sent an email to the above address with a reset link. If you do not receive it in the next few minutes please check your junk mail.",
  password_reset_successful: "Your password has been reset, you may now log in",
  password_reset_prompt: "Set a new password for",
  submit_label_reset: "Set new password",
  submit_label_edit: "Save",
  profile_title: "Your Profile",
  contacts: "Contact",
  add_contact: "Add a contact method",
  add_link: "Add Web link",
  add_sponsor: "Add sponsor",
  add_event: "Add event",
  phone: "Phone",
  themes: "Tags",
  contact: "Contact",
  course: "Pathway / platform",
  no_courses: "There are no courses",
  links: "Links",
  events: "RCA Scheduled Events",
  event_link: "Event link",
  shop_link: "Link to external text",
  work_links: "Artist collaborators & role in project",
  sponsors: "Sponsor",
  program: "Programme",
  program_placeholder: "Full programme name",
  course_placeholder: "Full course name",
  college_placeholder: "School within RCA",
  education: "RCA Degree",
  college: "School",
  enter_media_title: "Please enter a title",
  mediaitem_review_suggested_label:
    "Please review title based on the source file name",
  statement: "Statement",
  work_save_no_media: "Save and add media",
  work_save_with_media: "Save",
  work_supporting_media_items: "Supportng media items",
  upload_media: "Upload images",
  one_or_more_media_items_need_title: "One or more media items need a title",
  delete_media_item_confirm_label: "Are you sure you wish to remove this?",
  add_media: "Add URL",
  click_to_add_image: "Click to add image",
  word_count: "Word count",
  help: "Help",
  description: "Description",
  pdf_description: "Description (optional)",
  medium: "Medium",
  size: "Size / duration",
  application_id_label: "Application ID",
  work_display_mode: "Column layout mode",
  work__display_options: "Container Display Options",
  mediaitem_display_mode: "Display mode",
  mediaitem_launch_url: "Launch URL",
  completed_label: "Updated",
  update_message:
    "Remote changes detected. Your submission was updated elsewhere",
  mediaitem__vimeo_format_error_label:
    "Please paste a URL in one of the following formats:",
  mediaitem__video_duration_error_label:
    "The linked video is longer than 2 hours",
  mediaitem__vimeo_already_added_error_label:
    "This video has already been added",
  submission__profile: "Your Profile",
  submission__works: "Containers",
  submission__order: "Order Containers",
  submission__add_work_label: "Add Container",
  submission__saved: "Submission saved",
  submission__updated_elsewhere:
    "Your submission has been updated on another device or in another browser",
  work__description_placeholder: "",
  work__explicit: "This work contains sexually explicit material",
  overview__explicit: "Sexually explicit",
  work__show_title: "Show this container title?",
  overview__show_title: "Show title",
  work__save_label: "Save Container",
  work__presave_label: "Save and add media",
  work__add_title: "Please add a container title",
  work__add_pdf: "Add PDF",
  submission__display_name_label: "Display name",
  submission__display_name_placeholder: "Display Name",
  submission__slug_label: "Slug",
  submission__slug_placeholder: "URL alias",
  submission__contact_help:
    "Please enter one or more other ways to contact you",
  submission__show_qr_code: "Show QR Code with contact details on my page",
  overview__show_qr_code: "Show QR Code",
  completion__title: "Review & Publish",
  completion__submit: "Review & Publish",
  completion__resubmit: "Resubmit",
  completion__published: "Published",
  completion__generate_preview: "Generate Preview",
  completion__last_saved_on: "Last saved on",
  completion__generate_generate_confirm:
    "Update request sent. to: Preview generation requested. Please wait 2 minutes for the preview to be built then click on the View Live Preview link.",
  completion__live_preview: "View Live Preview",
  completion__live_preview_notes:
    "Please note the live preview is generated every 15 minutes.",
  explanation__external_url: "Link to launch external website",
  explanation__color_mode: "Background colour for slideshow",
  explanation__drag_container_icon:
    "Drag these icons up and down to re-order your containers",
  media_items__title: "Your media items:",
  image_mouse_over: "Mouseover image to check if it has uploaded yet",
  site__deadline_logout_message:
    "The upload period has finished. We're logging you out now.",
  site__inactive_logout_message:
    "Your account is inactive. Please contact the RCA support team",
  msal_pop_help:
    "Press the blue button below to authenticate via RCA Login Service. You may need to enable popups in your browser settings",
  multifactor_auth_required:
    "Two-factor authentication is required for your RCA account.",
  msal_login_popup:
    "We cannot log you in with this user name and password. please try signing in via the  RCA Login Service instead.",
  azure_login_button: "Sign in via RCA Login Service",
  programme_expired: "Sorry. Your programme deadline is over.",
  media_item_limit_hint: "You've added %num of a maximum of %max media items",
  media_item_max_limit_reached:
    "You've reached the maximum limit of %max media items",
  media_item__show_title:
    "Show media title?",
  work__expand_media_items: "Edit mode",
  work__contract_media_items: "Sort mode",
  work__expand_media_items_help: "Click to switch back to normal edit mode",
  work__pdf_attachments: 'Downloadable PDF(s)',
  site__invalid_color_option: 'Please select contrasting colour options',
  alt_text: 'Alt text',
  character_count: 'Character count',
  submission__check_errors: 'Please check errors before proceeding',
  alt_text_long: 'Please enter alternative text for accessibility (not visible on page)'
};
